import { TDispatch } from 'state';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import { Message, PerspectiveTag, TextAnalyzerTag } from '../types';
import { getMessageTagsSpans } from '../../api/highlight-tags/get-message-tags-spans';
import { fetchMessageTagsSpansSuccess } from './index';
import { showToast } from '../../../../../../components/toast/toastSlice';

const fetchMessageTagsSpans = (
  message: Message,
  tagName: TextAnalyzerTag,
  vendorType: PerspectiveTag.GOOGLE_PERSPECTIVE
) => {
  return async (dispatch: TDispatch): Promise<void> => {
    try {
      const messageContent: string = message.getText();
      const messageId: string = message.get('id');
      const highlightedTagSpans = message.get('highlightedTagSpans', {});
      const isHighlightedTagSpansEmpty = Object.keys(highlightedTagSpans || {})?.length === 0;

      if (!isHighlightedTagSpansEmpty) {
        if (
          highlightedTagSpans?.selectedTagName !== tagName &&
          !highlightedTagSpans?.spanScoreResults?.[tagName]
        ) {
          dispatch(
            showToast({
              type: 'warning',
              message: 'Sorry, Couldn’t find sentences to highlight'
            })
          );
          AnalyticsProvider.track('highlight tag no tag error displayed', { vendorType });
          return;
        }
        dispatch(
          fetchMessageTagsSpansSuccess({
            messageId,
            tagName,
            spanScoreResults: highlightedTagSpans,
            isEmpty: false
          })
        );
        return;
      }

      const result = await getMessageTagsSpans(messageContent);

      const spanScoreResults = result?.[parseVendorName(vendorType)]?.span_scores;

      if (
        spanScoreResults &&
        Object.keys(spanScoreResults || {})?.length > 0 &&
        spanScoreResults[tagName]
      ) {
        dispatch(
          fetchMessageTagsSpansSuccess({
            messageId,
            tagName,
            spanScoreResults,
            isEmpty: isHighlightedTagSpansEmpty
          })
        );
      } else {
        dispatch(
          showToast({
            type: 'warning',
            message: 'Sorry, Couldn’t find sentences to highlight'
          })
        );
        AnalyticsProvider.track('highlight tag no tag error displayed', { vendorType });
      }
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to highlight message spans for tag`, {
        tagName,
        vendorType,
        messageId: message.get('id')
      });
      AnalyticsProvider.track('highlight tag failed error displayed', { vendorType });
      dispatch(showToast({ type: 'error', message: 'Something went wrong! Please try again' }));
    }
  };
};

function parseVendorName(vendorType: string): string {
  switch (vendorType) {
    case PerspectiveTag.GOOGLE_PERSPECTIVE:
      return 'perspective';
    default:
      return 'perspective';
  }
}

export default fetchMessageTagsSpans;
